import type { PublicVesselSummary } from "../shared/contracts";

/** Vessels seaward of Brickell that can enter a user-selected follow view. */
export function inboundBayApproachVessels(
  vessels: readonly PublicVesselSummary[],
): PublicVesselSummary[] {
  return vessels
    .filter((vessel) => vessel.direction === "inbound" && vessel.sMeters < 0)
    .sort((left, right) => Math.abs(left.sMeters) - Math.abs(right.sMeters));
}
